"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.login = exports.profileAndPreferences = exports.error = exports.contactSupport = exports.api = void 0;
var QA_SUFFIX = window.location.href.indexOf('hubspotqa.com') !== -1 ? 'qa' : '';
var IS_LOCAL = window.location.href.indexOf('://local.hubspot') !== -1;
var IS_API_LOCAL = window.localStorage && window.localStorage.HOME_API_ENV === 'local';
var APP_ROOT_PATH = "https://app.hubspot" + QA_SUFFIX + ".com";
var LOCAL_APP_ROOT_PATH = "https://local.hubspot" + QA_SUFFIX + ".com";
var API_ROOT_PATH = "https://api.hubspot" + QA_SUFFIX + ".com";
var LOCAL_API_ROOT_PATH = "https://local.hubspot" + QA_SUFFIX + ".com";

var api = function api(path) {
  var root = IS_API_LOCAL ? LOCAL_API_ROOT_PATH : API_ROOT_PATH;
  return "" + root + path;
};

exports.api = api;

var contactSupport = function contactSupport() {
  return 'mailto:support@hubspot.com';
};

exports.contactSupport = contactSupport;

var error = function error() {
  var root = IS_LOCAL ? LOCAL_APP_ROOT_PATH : APP_ROOT_PATH;
  return root + "/home-beta/error" + window.location.search;
};

exports.error = error;

var profileAndPreferences = function profileAndPreferences(portalId) {
  return APP_ROOT_PATH + "/user-preferences/" + portalId;
};

exports.profileAndPreferences = profileAndPreferences;

var login = function login(portalId) {
  if (!portalId) {
    return APP_ROOT_PATH + "/login";
  }

  return APP_ROOT_PATH + "/login?loginPortalId=" + portalId;
};

exports.login = login;